<template>
  <div class="list mb-3" v-if="establishments && Object.keys(establishments).length > 0">
    <h2 class="textStyle">{{ title }}</h2>
    <div class="list__row list__heading">
      <div class="list__column">{{ $t("registration.insee_company.siret") }}</div>
      <div class="list__column">{{ $t("registration.insee_company.activity") }}</div>
      <div class="list__column">{{ $t("registration.insee_company.details") }}</div>
      <div class="list__column">{{ $t("registration.insee_company.creation") }}</div>
      <div class="list__column">{{ $t("registration.insee_company.state") }}</div>
    </div>
    <template v-for="company in establishments" :key="company.id">
      <div class="list__row">
        <div class="list__column">
          <span class="list__mobileHeading">{{ $t("registration.insee_company.siret") }}</span>
          {{ company.siret }}
        </div>
        <div class="list__column">
          <span class="list__mobileHeading">{{ $t("registration.insee_company.activity") }}</span>

          {{ company.nafNomenclatureCompanyActivity?.label }} ({{ company.nafNomenclatureCompanyActivity?.code }})
        </div>
        <div class="list__column">
          <span class="list__mobileHeading">{{ $t("registration.insee_company.details") }}</span>

          {{ company.address }},
          {{ company.addressComplement ? company.addressComplement + "," : "" }}
          {{ company.addressCity ? company.addressCity.postCode : "" }}
          {{ company.addressCity ? company.addressCity.name : "" }}
          <span v-if="company.establishmentHeadOffice" class="badge bg-info ms-md-2 ms-0">
            {{ $t("registration.head_office") }}
          </span>
        </div>
        <div class="list__column">
          <span class="list__mobileHeading">{{ $t("registration.insee_company.creation") }}</span>

          {{ company.legalUnitCreationDate ? dateFormatter().format(company.legalUnitCreationDate, "short") : "" }}
        </div>
        <div class="list__column">
          <span class="list__mobileHeading">{{ $t("registration.insee_company.state") }}</span>
          <span
            class="badge"
            :class="{
              'bg-success': company.legalUnitAdministrativeStatus === 'A',
              'bg-danger': company.legalUnitAdministrativeStatus !== 'A',
            }"
            >{{ company.legalUnitAdministrativeStatus === "A" ? "En activité" : "Fermé" }}</span
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";

export default {
  components: {},
  props: {
    establishments: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    dateFormatter() {
      return dateFormatter;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  border: 1px dashed $m-color_6;
  border-radius: $radius;
  padding: 15px;
  &__row {
    display: flex;
    padding: 5px 0;

    &.list__row {
      border-bottom: 1px dashed $m-color_6;
    }

    &:last-child {
      border-bottom: none;
    }

    @include up-to-md {
      flex-direction: column;
    }
  }

  &__heading {
    color: var(--primary-color);
    font-weight: 700;
    font-size: 16px;
    border-bottom: 1px dashed $m_color_6;
    margin-top: 5px;

    @include up-to-md {
      display: none;
    }
  }

  &__mobileHeading {
    display: none;
    @include up-to-md {
      display: block;
      font-weight: 700;
    }
  }

  &__column {
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 40%;
    }
    &:nth-child(4) {
      width: 10%;
    }
    &:nth-child(5) {
      width: 10%;
    }

    @include up-to-md {
      width: 100% !important;
    }
  }
}
</style>
